import { NgModule } from '@angular/core';
import { Dash2HandComponent } from "./dash-2hand.component";
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';


@NgModule({
    imports: [
        CommonModule,
        ChartModule,
        TranslateModule,
        CalendarModule,
        FormsModule
    ],
    declarations: [
        Dash2HandComponent
    ],
    exports: [
        Dash2HandComponent
    ],

})
export class Dash2HandModule { }